<template>
    <div class="cases">
      <Helmet>
        <title>Testimonials - inte-QT</title>
        <meta name="title" content="Testimonials - inte-QT" />
        <meta name="description" content="Testimonials from our customers demonstrating the quality of the service we offer" />
        <link rel="canonical" href="https://www.inte-qt.com/testimonials" />
      </Helmet>
  
      <img src="/images/17SWB8I.jpg" alt="1" class="banner-img banner-img__black" />
      <h1 class="banner-img__header text-center">Testimonials</h1>
  
      <div class="container">
        <div class="cases__card">
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <h2 class="cases__companyName mx-3">Delivering for the Highest Class of International Racing.</h2>
              <p class="cases__text m-3" align="justify">
                <strong class="blue">Brilliant</strong> work by inte-QT. <br /><br />
                It was seamlessly managed by inte-QT, right from Quotation to timely delivery well within event schedule.
                Overall it's a delightful experience.
              </p>
              <div class="text-end mx-3">
                <DinamicLink url="/testimonials/mx" name="Read more" />
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <img src="/images/6Q7TYsB.jpg" alt="1" class="cases__img" />
            </div>
          </div>
        </div>
      </div>
  
      <ConnectivitySolutions />
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import DinamicLink from '@/components/DinamicLink.vue';
  import ConnectivitySolutions from '@/components/ConnectivitySolutions.vue';
  import GetInTouch from '@/components/GetInTouch.vue';
  
  export default {
    name: 'TestimonialPage',
    components: {
      DinamicLink,
      ConnectivitySolutions,
      GetInTouch
    },
    mounted() {
      window.scrollTo(0, 0);
    }
  }
  </script>
  
  <style scoped>
  @import '@/assets/css/Variables.css';
  
  .cases__card {
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding: 2rem;
    margin: 2rem auto;
    transition: box-shadow 0.3s ease-in-out;
  }
  
  .cases__card:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }
  
  .cases__img {
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
  }
  
  .testimonials__question {
    font-weight: 600;
  }
  
  .banner-img {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
  }
  
  .banner-img__header {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5.5rem;
  font-weight: bold;
  color: #fff;
  text-align: center;
  width: 90%;
  z-index: 1;
}

@media (max-width: 992px) {
  .banner-img__header {
    font-size: 4rem;
  }
}

@media (max-width: 768px) {
  .banner-img__header {
    font-size: 2.8rem;
  }
}

@media (max-width: 480px) {
  .banner-img__header {
    font-size: 2rem;
    width: 95%;
    top: 279px;
  }
}

  
  .blue {
    color: #007bff;
  }
  </style>
  